import { Injectable } from '@angular/core';
import { Title, DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable()
export class AppUtilService {
  private title: string;

  constructor(
    private titleService: Title,
    private sanitizer: DomSanitizer
  ) {}

  public getTitle(): string {
    return this.title;
  }

  public setTitle(title: string): void {
    this.titleService.setTitle('Authentication - ' + title);
    this.title = title;
  }

  public getRawText(html: SafeHtml): string {
    // convert SafeHtml to a string
    const htmlString: string = this.sanitizer.sanitize(1, html);
    // create a div to strip out the HTML tags
    const div = document.createElement('div');
    // store the html string to the div's innerHTML attribute
    div.innerHTML = htmlString;
    // return the div's innerText attribute to strip out the HTML tags
    return div.innerText;
  }

}
